/**
 * AnimatedLogo - Kata.fit lockup using the Echo brand mark.
 */

import React, { useEffect, useState } from 'react';
import './AnimatedLogo.css';
import EchoBrandMark from './EchoBrandMark';

const AnimatedLogo = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`animated-logo-container ${loaded ? 'loaded' : ''}`}>
      <EchoBrandMark className="animated-logo-mark" decorative />
      <div className="auth-brand-wordmark">Kata<span>.</span>fit</div>
    </div>
  );
};

export default AnimatedLogo;
